module.exports = __webpack_public_path__ + "img/coffee-beans.0847fcb7.png";